import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { SmeProfileApi } from '../tokens/sme-profile.token';
import { CompanyProfileView, CompanyProfileUpdate, ProfileUpdateResult } from '../models/sme-profile.model';

/** The dedicated SCA header (never `Authorization` — that stays the Keycloak bearer). */
const SCA_TOKEN_HEADER = 'X-SCA-Token';

/**
 * REST-only implementation of `SmeProfileApi` (Story E / EM-472, PR-01 / I-01).
 *
 * Calls:
 *   GET   /services/embedded/api/me/profile
 *   PATCH /services/embedded/api/me/profile   (+ X-SCA-Token: profile_update)
 *
 * Rides the existing Keycloak bearer (attached by `authInterceptor`). The SCA token is added
 * only on the PATCH via the `X-SCA-Token` header. Rule 07 / Rule 10 — no Mock; Playwright
 * intercepts via `page.route()`. Error surfacing (Rule 09) is the caller's responsibility via
 * `extractBackendErrorMessage` — this service propagates the raw `HttpErrorResponse`.
 */
@Injectable()
export class SmeProfileRestService implements SmeProfileApi {
  private readonly http = inject(HttpClient);
  private readonly base = API_PATHS.ME_PROFILE;

  getProfile(): Observable<CompanyProfileView> {
    return this.http.get<CompanyProfileView>(this.base);
  }

  updateProfile(patch: CompanyProfileUpdate, scaToken: string): Observable<ProfileUpdateResult> {
    const headers = new HttpHeaders().set(SCA_TOKEN_HEADER, scaToken);
    return this.http.patch<ProfileUpdateResult>(this.base, patch, { headers });
  }
}
